import { createContext } from "react";
import { Markdown } from "./Markdown";
import { StandardDialog } from "./StandardDialog";
import { StandardPopover } from "./StandardPopover";
/**
 * These are components that are read from the {@link CommonComponentsContext} in multiple places
 */
export const CommonComponents = {
    StandardPopover,
    StandardDialog,
    Markdown,
};
export const CommonComponentsContext = createContext(CommonComponents);
CommonComponentsContext.displayName = "CommonComponentsContext";
//# sourceMappingURL=CommonComponents.js.map